import { Component, Input } from '@angular/core';

@Component({
    selector: 'validation-messages',
    templateUrl: 'validation-messages.component.html',
    standalone: false
})
export class ValidationMessagesComponent {
	@Input() public messages: string[];
}
